import { BaseDataItem } from '@wix/document-services-types'
import { Data, RefSchemas } from '@wix/thunderbolt-becky-types'
import { DataWithDrafts } from './dataResolvingTypes'
import { isDraftDataItem } from './dataResolvingUtils'

export const createSchemaManager = (schemas: RefSchemas) => {
	const sameMapRefs: RefSchemas = {}

	// Remove cross maps refs because in CARMI we can't resolve them (while in catharsis we do resolve them)
	const getSchemaByType = (mapName: keyof Data, dataType: string) => {
		if (!sameMapRefs[mapName]?.[dataType]) {
			sameMapRefs[mapName] = sameMapRefs[mapName] ?? {}
			const filteredRefs = schemas[`${mapName}.json`]?.[dataType]?.filter(
				({ referencedMap }) => referencedMap === mapName
			)
			sameMapRefs[mapName][dataType] = filteredRefs
		}

		return sameMapRefs[mapName][dataType]
	}

	const getSchemaFromDataItem = (mapName: keyof Data, dataItem: DataWithDrafts | BaseDataItem) => {
		if (!dataItem) {
			return undefined
		}

		if (isDraftDataItem(dataItem)) {
			return dataItem._draftRefs?.filter(({ referencedMap }) => !referencedMap || referencedMap === mapName)
		}

		return getSchemaByType(mapName, dataItem.type)
	}

	return { getSchemaFromDataItem, getSchemaByType }
}
